import React, { Component } from "react";
import "./TestYourKnowledgePage.scss";
import { connect } from "react-redux";
import OptionsMenuPageHeader from "../OptionsMenuPageHeader";
import { saveTestUserDetails } from "../../actions";
import $ from "jquery";

class TestYourKnowledgePage extends Component {
  constructor() {
    super();
    this.state = {
      userName: "",
      userEmail: "",
      userPassword: "",
      setFixedBtn: false,
    };
  }

  componentDidMount() {
    const { cookies } = this.props;
    const existingCookie = cookies.get("app_settings");

    if (existingCookie && existingCookie.user_details) {
      if (existingCookie.user_details.name) {
        this.setState({
          userName: existingCookie.user_details.name,
          userEmail: existingCookie.user_details.email,
          userPassword: existingCookie.user_details.password,
        });
      }
    }
    this.resetActionButtonPosition();
    window.addEventListener("resize", this.resetActionButtonPosition);
    this.interval = setInterval(() => {
      this.resetActionButtonPosition();
    }, 10);
    setTimeout(() => {
      clearInterval(this.interval);
    }, 20000);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resetActionButtonPosition);
    clearInterval(this.interval);
  }

  resetHeaderPosition = () => {
    if ($(".menu-header-container")) {
      let headerHeight = $(".menu-header-container").outerHeight();
      $(".page-content").css("padding-top", headerHeight + 0 + "px");
    }
  };

  resetActionButtonPosition = () => {
    let windowHeight = $(window).height();
    let documentHeight = $(document).height();
    this.setState({
      setFixedBtn: !(documentHeight > windowHeight),
    });
    this.resetHeaderPosition();
  };

  onClickBegin = () => {
    const userDetails = {
      name: this.state.userName,
      email: this.state.userEmail,
      password: this.state.userPassword,
    };
    const { cookies } = this.props;
    let appSettings = cookies.get("app_settings");
    appSettings.user_details = userDetails;
    cookies.set("app_settings", appSettings);
    this.props.saveTestUserDetails(userDetails);
    // TODO Jump directly here from main menu!!!
    this.props.history.push("/fastquiz", { showQuiz: "1", isTest: "1" });
  };

  onChangeInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  render() {
    const { setFixedBtn, userName, userEmail, userPassword } = this.state;
    this.resetHeaderPosition();
    return (
      <div className="test-your-knowledge-page">
        <OptionsMenuPageHeader
          goBack={() => {
            this.props.history.goBack();
          }}
          headerTitle="Full Test"
        />
        <div className="page-content">
          <div className="page-data-container">
            <div className="content-row">
              <div className="single-row">
                <div className="row-title">Your Name:</div>
                <div className="row-data">
                  <input
                    type="text"
                    name="userName"
                    value={userName}
                    onChange={this.onChangeInput}
                  />
                </div>
              </div>
              <div className="single-row">
                <div className="row-title">Your Email:</div>
                <div className="row-data">
                  <input
                    type="email"
                    name="userEmail"
                    value={userEmail}
                    onChange={this.onChangeInput}
                  />
                </div>
              </div>
              <div className="single-row">
                <div className="row-title">Your Password:</div>
                <div className="row-data">
                  <input
                    type="text"
                    name="userPassword"
                    value={userPassword}
                    onChange={this.onChangeInput}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={
              "action-btn-container" + (setFixedBtn ? " fixed-position" : "")
            }
          >
            <div
              className={
                "action-btn" +
                (userName && userEmail && userPassword ? "" : " disabled")
              }
              onClick={this.onClickBegin}
            >
              Begin
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default connect(null, { saveTestUserDetails })(TestYourKnowledgePage);
